import React from 'react';
import { CnBox } from '@/components/cn-box';
import { CnSafeArea } from '../cn-safe-area';
class CnDrawerFooter extends React.Component {
    static __type = 'DrawerFooter';
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement(CnBox, { direction: "row", spacing: 8, justify: "space-between", align: "center", className: "cn-ui-m-drawer-footer" }, this.props.children),
            React.createElement(CnSafeArea, null)));
    }
}
export { CnDrawerFooter };
